import { render, staticRenderFns } from "./RoundDetails.vue?vue&type=template&id=b018e9aa&scoped=true&"
import script from "./RoundDetails.vue?vue&type=script&lang=js&"
export * from "./RoundDetails.vue?vue&type=script&lang=js&"
import style0 from "./RoundDetails.vue?vue&type=style&index=0&id=b018e9aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b018e9aa",
  null
  
)

export default component.exports